export default "__VITE_ASSET__3af73c48__"